import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { BrowserService } from "./services/browser.service";

@NgModule({
	imports: [CommonModule],
	providers: [BrowserService]
})
export class BrowserModule {}
